import { cScene } from "../../cScene";
import { cButton } from "../cButton";
import { cContainer } from "../cContainer";
import { cObject } from "../cObject";
import { Module } from "./Module";


export class Debug extends Module{

  public events: Phaser.Events.EventEmitter = new Phaser.Events.EventEmitter();

  private _debugRect:any
  private _dragRect:any

  public debugMode(opt:boolean, cb?:Function ){
    let cS = this.ref.scene as cScene;
    if (opt){
      this.events.emit('start')
      
      this._debugRect = new Phaser.GameObjects.Graphics(cS) //  this.ref.add.graphics();
      var b = this.ref.getBounds()
      this._debugRect.lineStyle(3, 0xff0000, 0.8);
      this._debugRect.x = b.x;
      this._debugRect.y = b.y;
      this._debugRect.strokeRect(0, 0, b.width, b.height);
      cS.add.existing(this._debugRect)

      
      if (this.ref instanceof cButton || this.ref instanceof cContainer || (this.ref as any).isContainer === true){
        // var yy: number = 100;        
        // if ( (this.ref as any)._height ){
        //   yy = (this.ref as any)._height / 2;
        // }
          
          this.ref.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(0, 0, 400, 128),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            draggable: true,
            useHandCursor: true
          });

          this._dragRect = new Phaser.GameObjects.Graphics(cS) //  this.ref.add.graphics();
          this._dragRect.fillStyle(0xff00ff, 0.3);
          this._dragRect.x = 0;
          this._dragRect.y = 0;
          this._dragRect.fillRect(0, 0, 400, 128);
          
          (this.ref as any).add(this._dragRect)
          

      }else{
        this.ref.setInteractive({useHandCursor:true});
      }

      if (!cS.input || !this.ref.input) return

      cS.input.setDraggable( this.ref )
      cS.input.enable(this.ref);

      cS.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
        if (gameObj !== this.ref) return
        gameObj.x = Math.round(x);
        gameObj.y = Math.round(y);
        if (this._debugRect){
          var b = this.ref.getBounds()
          this._debugRect.setPosition(b.x,b.y)
        }
      });

      cS.input.on('dragend',(p:any, gameObj:any)=>{
        if (gameObj !== this.ref) return
        var r:cObject = this.ref as any;
        //r.dataItem.ofs = r.modules.layout.ofs;
        cS.events.emit(
          'debug_position', 
          this.data, 
          r.modules.layout.ofs, 
        )
        console.log(r.modules.layout.ofs)
        this.ref.emit('')
      })


    }else{
      if (cS && cS.input){
        //console.log( this.ref, this.ref.input );
        //this.ref.input
        cS.input.disable(this.ref);
      }
      if (this._debugRect){
        this._debugRect.destroy();
        this._debugRect = null  
      }
      if (this._dragRect){
        this._dragRect.destroy();
        this._dragRect = null  
      }
      this.events.emit('end')
    }
  }


}
